// extracted by mini-css-extract-plugin
export default {"dimension":"LfqhD","parameter":"ZoSdm","select":"BHJ3q","selects":"N6bOy","dimensions":"l7MbX","hardness":"YbzNC"};